import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/primary_white_logo.svg';
import { supabase } from '../supabaseClient';
import '../styles/login.css';

export default function InvestorsLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) return setErr(error.message);
    navigate('/investor-portal');
  };

  const handleForgot = () => {
    setErr('Please contact the administrator to request a new password.\ndev@erebus.capital');
  };

  return (
    <div className="page page--center">
      <div className="panel-card login-card">
        <button type="button" className="card-logo" onClick={() => navigate('/')} aria-label="Back to home">
          <Logo />
        </button>

        <h2 className="card-title">Investor Login</h2>
        <div className="card-divider"></div>

        <form onSubmit={onSubmit} className="login-form">
          {/* Email */}
          <div className="input-wrap">
            <span className="input-icon-left" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M4 6h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1Z" stroke="currentColor" strokeWidth="1.5"/>
                <path d="m4 7 8 6 8-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
            <input
              type="email"
              className="login-input"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
            />
          </div>

          {/* Password */}
          <div>
            <div className="input-wrap">
              <span className="input-icon-left" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M8 10V8a4 4 0 1 1 8 0v2" stroke="currentColor" strokeWidth="1.5"/>
                </svg>
              </span>

              <input
                type={showPw ? 'text' : 'password'}
                className="login-input"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />

              <button
                type="button"
                className="input-icon-right"
                aria-label={showPw ? 'Hide password' : 'Show password'}
                onClick={() => setShowPw(!showPw)}
              >
                {showPw ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M1 12s3.5-7 11-7 11 7 11 7-3.5 7-11 7S1 12 1 12Z" stroke="currentColor" strokeWidth="1.5"/>
                    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/>
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M3 3l18 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    <path d="M10.6 10.6A2.001 2.001 0 0 0 12 14a2 2 0 0 0 1.4-3.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    <path d="M6.7 6.7C4.9 7.9 3.6 9.6 3 12c1.7 5 7 7 9 7 1.2 0 3.6-.6 5.9-2.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                    <path d="M20.7 16.7C21.7 15.5 22.4 14 23 12 21.3 7 16 5 14 5c-.6 0-1.6.1-2.7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                )}
              </button>
            </div>

            <div className="forgot-row">
              <button type="button" className="forgot-link" onClick={handleForgot}>
                Forgot password?
              </button>
            </div>
          </div>

          <button type="submit" className="pill-btn" disabled={loading}>
            {loading ? 'Logging in…' : 'Log In'}
          </button>
        </form>

        {err && <p className="login-error">{err}</p>}
        <p className="login-caption">
          If you don’t have an account, please make use of our contact form on the home page and a
          member of our team will be in touch with you.
        </p>
      </div>
    </div>
  );
}
